import dayjs from 'dayjs';

import { BookingStateEnum, PassengerBookingView } from '@mopla/data-models';
import { getItineraryTimingV2, getMoplaLegs } from '@mopla/utils';

/** How long a finished ride stays ratable after it ends. */
export const RATING_WINDOW_MONTHS = 1;

/** Whether the rating window of a finished ride is still open. */
export const isBookingRatable = (booking: PassengerBookingView): boolean => {
	const moplaLegs = getMoplaLegs(booking.itinerary.legs);

	if (
		!moplaLegs.length ||
		booking.bookingStatus !== BookingStateEnum.FINISHED
	) {
		return false;
	}

	const { effectiveEndDateObj } = getItineraryTimingV2(moplaLegs);

	return dayjs(effectiveEndDateObj)
		.add(RATING_WINDOW_MONTHS, 'month')
		.isAfter(dayjs());
};
